import React from 'react'

export const PreviewItem = (props: any) => {
  return <p>{ props.value }</p>
}
